import { Globe } from '@phosphor-icons/react';

export default Globe;
